import { Component, Event, EventEmitter, h, Element } from "@stencil/core";

@Component({
  tag: "gx-pia-send-control",
  styleUrl: "pia-send-control.scss",
  shadow: true
})

export class PiaSendControl {
    @Element() element:HTMLElement;
    @Event() send: EventEmitter<string>;

    private _handleOnClickSend(){
        let textArea:any = this.element.shadowRoot.querySelector("gxg-form-textarea");
        this.send.emit((textArea.value as string).trim());
        textArea.value = "";
    }

    render() {
        return (
            <div class="controls">
                <gxg-separator 
                    type="solid"
                    margin="m"
                />
                <div>
                    <gxg-form-textarea class="textInput"
                        max-width="100%"
                        placeholder="Type yor message..."
                        rows={2}
                    />
                    <gxg-button class = "sendButton"
                        type="outlined"
                        onClick={() => this._handleOnClickSend()}
                    >
                        Send
                    </gxg-button>
                </div>
            </div>
        );
    }
}
